import { render, staticRenderFns } from "./ModalAlertSameFileUpload.vue?vue&type=template&id=64a275ed&scoped=true&"
import script from "./ModalAlertSameFileUpload.vue?vue&type=script&lang=js&"
export * from "./ModalAlertSameFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertSameFileUpload.vue?vue&type=style&index=0&id=64a275ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a275ed",
  null
  
)

export default component.exports